document.addEventListener("DOMContentLoaded", function () {

  let gemstonesMenuHTML = null;
  let loadingMenu = null;

  async function getGemstonesMenu() {
    if (gemstonesMenuHTML) return gemstonesMenuHTML;
    if (loadingMenu) return loadingMenu;

    loadingMenu = fetch('/?sections=all-gemstones-menulist')
      .then(res => res.json())
      .then(data => {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = data['all-gemstones-menulist'];

        const menu = wrapper.querySelector('.all-gemstones-menulist');

        if (!menu) {
          console.error('all-gemstones-menulist not found');
          return '';
        }

        gemstonesMenuHTML = menu.innerHTML;
        return gemstonesMenuHTML;
      })
      .catch(err => {
        console.error(err);
        return '';
      });

    return loadingMenu;
  }

  async function populateSubmenu(li) {
    if (li.dataset.loaded === "true") return;

    const submenu = li.querySelector('.gemstone-sub-menu');
    if (!submenu) return;

    submenu.innerHTML = await getGemstonesMenu();
    submenu.classList.add('sub-menu');

    li.dataset.loaded = "true";
  }

  // -----------------------
  // Desktop
  // -----------------------
  document.querySelectorAll('.desktop_gemstone_list').forEach(li => {
    li.addEventListener('mouseenter', () => {
      populateSubmenu(li);
    }, { once: true });
  });

  // -----------------------
  // Mobile
  // -----------------------
  document.querySelectorAll('.gemstone_list:not(.desktop_gemstone_list)').forEach(li => {
    li.addEventListener('click', () => {
      populateSubmenu(li);
    }, { once: true });
  });

  // -----------------------
  // Preload when browser is idle
  // -----------------------
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      getGemstonesMenu();
    }, {
      timeout: 10000
    });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(() => {
      getGemstonesMenu();
    }, 8000);
  }

});

window.addEventListener("load", function () {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {

      const variantIds = new Set(
        cart.items.map(item => String(item.variant_id))
      );

      document.querySelectorAll(".quick-add__submit[data-variant-id]").forEach(button => {

        if (variantIds.has(button.dataset.variantId)) {
          const span = button.querySelectorAll('span')[0]; 
            if(span){
              span.textContent = "Added";
              button.disabled = true; // optional
              button.classList.add("add_cart_success");
            }
        }

      });

    })
    .catch(() => {});
});

document.addEventListener("DOMContentLoaded", function () {

/*
  Add-to-Cart - Collection page */
  document.querySelectorAll(".quick-add__submit").forEach(function (button) {
    button.addEventListener("click", function () {
      // Find the closest product card wrapper for the clicked button
      const productCard = button.closest(".product-card-wrapper");
      if (!productCard) return;
      const mediaCard = productCard.querySelector(".card__media");
        if (!mediaCard) return;
      // Clone the media card
      const clone = mediaCard.cloneNode(true);

      // Get the product card's position and dimensions relative to the viewport
      const rect = mediaCard.getBoundingClientRect();

      // Set initial styles for the clone so it overlays the original element
      clone.style.position = "fixed";
      clone.style.top = rect.top + "px";
      clone.style.left = rect.left + "px";
      clone.style.width = rect.width + "px";
      clone.style.height = rect.height + "px";
      clone.style.zIndex = "9999";
      clone.style.pointerEvents = "none";

      // Optionally add a class for additional styling
      clone.classList.add("fly-clone");

      // Append the clone to the body
      document.body.appendChild(clone);

      // Get the destination coordinates from the header icons element

      var cart_element = ".header__icons";
      if (window.innerWidth < 989) {
        cart_element = ".header__icons .header__icon--cart";
      }
      const cartIcon = document.querySelector(cart_element);
       
      if (cartIcon) {
        const iconRect = cartIcon.getBoundingClientRect();

        // Calculate the difference between the centers of the product card and the header icon
        const deltaX = iconRect.left + iconRect.width / 2 - (rect.left + rect.width / 2);
        const deltaY = iconRect.top + iconRect.height / 2 - (rect.top + rect.height / 2);
      
        // Apply a smooth transition to animate the clone moving towards the header icon
        clone.style.transition = "transform 1s ease-in-out, opacity 1s ease-in-out";
        clone.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.2)`;
        clone.style.opacity = "0";
      }

      // Remove the clone after the animation completes
      setTimeout(function () {
        clone.remove();
      }, 1000);
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // A–Z sticky bar scroll (scoped to submenu only)
  document.addEventListener("click", function (e) {
    const link = e.target.closest(".custom_mega_menu .header-alphabet-nav a");
    if (!link) return;

    e.preventDefault();

    const submenu = link.closest(".sub-menu");
    if (!submenu) return;

    const targetId = link.getAttribute("href").substring(1);
    const targetEl = submenu.querySelector("#" + CSS.escape(targetId));
    if (!targetEl) return;

    let scroll_to_value = window.innerWidth < 980 ? 100 : 50;

    submenu.scrollTo({
      top: targetEl.offsetTop - scroll_to_value,
      behavior: "smooth"
    });
  });

  // --- Sticky Search Header ---
  const stickySearchHeader = document.querySelector('.sticky-search-header');
  if (stickySearchHeader) {
    stickySearchHeader.addEventListener('click', function (e) {
      e.preventDefault();

      // Scroll to top of body
      window.scrollTo({
        top: document.body.offsetTop,
        behavior: 'smooth' // smooth scroll
      });

      // Focus the search input
      const searchInput = document.querySelector('#search-input');
      if (searchInput) {
        searchInput.focus();
      }
    });
  }
});

/* for opal like collection sub-category */
document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const container = document.getElementById('opal-subcategory');
  if (!container) return; 

  const filterCollection = params.get('filter_collection');
  if (!filterCollection) return;

  document.querySelectorAll('#opal-subcategory .sub-filter-cat').forEach(li => {
    if (li.dataset.id === filterCollection) {
      li.classList.add('active');
    } else {
      li.classList.remove('active');
    }
  });
});

/* forcefully closing filter */
document.addEventListener('DOMContentLoaded', function () {
  let activeFilterName = null;
  let isSyntheticClick = false;

  document.addEventListener(
    'click',
    function (e) {
      const header = e.target.closest('.cloud-search-filter__name');
      if (!header) return;

      if (window.innerWidth < 990) return;

      const filter = header.closest('.cloud-search-filter');
      const filterName = filter.getAttribute('data-filter-name');

      // If this is a synthetic click, let it pass only for closing
      if (isSyntheticClick) {
        // prevent this click from affecting other filters
        return;
      }

      // real user click
      activeFilterName = filterName;

      // Let XCloud open current filter first
      setTimeout(() => {
        document.querySelectorAll('.cloud-search-filter').forEach((item) => {
          const name = item.getAttribute('data-filter-name');
          if (name === activeFilterName) return;

          const isOpen =
            item.querySelector('.cloud-search-filter__values') ||
            item.querySelector('.cloud-search-range-inputs');

          if (isOpen) {
            const headerEl = item.querySelector('.cloud-search-filter__name');
            if (!headerEl) return;

            //  mark as synthetic
            isSyntheticClick = true;
            headerEl.click();
            isSyntheticClick = false;
          }
        });
      }, 80);
    },
    true
  );
});

/* for blog sub-category */
document.addEventListener('DOMContentLoaded', function () {
  const heading = document.querySelector('.blog-category-heading');
  const targetEle = document.querySelector('.blog-cat-nav');
  let scrolled = false;

  if (heading && targetEle) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 0 && !scrolled) {
        targetEle.classList.add('is-scrolled');
        scrolled = true;
      } else if (window.scrollY === 0 && scrolled) {
        targetEle.classList.remove('is-scrolled');
        scrolled = false;
      }
    });
  }

  const blogList = document.querySelector('.blog-list');
  const header = document.querySelector('.blog-category-header');
  if (blogList && header){

    let blogListVisible = false;

    // Observe blog-list visibility (paint / viewport)
    const observer = new IntersectionObserver(
      ([entry]) => {
        blogListVisible = entry.isIntersecting;
        toggleClass();
      },
      { threshold: 0 }
    );

    observer.observe(blogList);

    // Scroll listener
    window.addEventListener('scroll', toggleClass);

    function toggleClass() {
      if (window.scrollY > 0 && blogListVisible) {
        header.classList.add('is-fixed');
      } else {
        header.classList.remove('is-fixed');
      }
    }
  }
});

/** remove cart drawer */
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener("click", function (e) {

    var removeBtn = e.target.closest(".cart-remove-button");
    if (!removeBtn) return;

    // Find cart item row
    var cartItem = removeBtn.closest(".cart-item");
    if (!cartItem) return;

    // Get product info div
    var productInfo = cartItem.querySelector(".product--info");
    if (!productInfo) return;

    // Extract data
    var productId = productInfo.dataset.id;
    var productTitle = productInfo.dataset.title;
    var productType = productInfo.dataset.type;
    var sku = productInfo.dataset.sku;
    var size = productInfo.dataset.size;
    var origin = productInfo.dataset.origin;
    var treatment = productInfo.dataset.treatment;
    var parentId = productInfo.dataset.parent_id;
    var parentTitle = productInfo.dataset.parent_title;
    var publish = productInfo.dataset.publish;
    var item_index = parseInt(productInfo.dataset.item_index);
    // Quantity
    var quantity = 1;

    // Price (clean number)
    var price = productInfo.dataset.price;
  /*  var priceEl = cartItem.querySelector(".money");
    var priceRaw = priceEl ? priceEl.getAttribute("original_price") : 0;
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;*/

    // Platform detect
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    var platform = isMobile ? "m-web" : "d-web";

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "remove_from_cart_ce",
      page_type: window.GA_CONTEXT?.page_type || "cart",
      total_qty : 1,
      platform: platform,
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status,
      ecommerce: {
        currency : "USD",
        value : price,
        items: [{
          item_id: sku,
          item_name: productTitle,
          affiliation: origin,
          item_category: productType,
          item_category2: treatment,
          item_variant: size,
          item_list_id: parentId,
          item_list_name: parentTitle,
          price: price,
          quantity: quantity,
          listng_date : publish,
          item_brand: "Gemstones For Sale",
          coupon:"NA",
          discount : 0,
          index : item_index
        }]
      }
    });

  });
});

// listing cart drawer data-layer
(function () {

  function getPlatform() {
    return window.matchMedia("(max-width: 768px)").matches ? "m-web" : "d-web";
  }

  function getCartItems() {
    var items = [];

    document.querySelectorAll('.cart-item').forEach(function (item) {

      var productInfo = item.querySelector('.product--info');
      if (!productInfo) return;

      var qty = 1;
      var priceRaw = item.querySelector('.money')?.getAttribute('original_price');
      var price = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

      items.push({
        item_id: productInfo.dataset.id,
        item_name: productInfo.dataset.title,
        affiliation: productInfo.dataset.origin,
        item_category: productInfo.dataset.type,
        item_category2: productInfo.dataset.treatment,
        item_variant: productInfo.dataset.size,
        item_list_id: productInfo.dataset.parent_id,
        item_list_name: productInfo.dataset.parent_title,
        price: productInfo.dataset.price,
        quantity: 1,
        listng_date : productInfo.dataset.publish,
        item_brand: "Gemstones For Sale",
        coupon:"NA",
        discount : 0,
        index : parseInt(productInfo.dataset.item_index)
      });

    });

    return items;
  }

  function getCartTotal() {
    var el = document.querySelector('.totals__total-value .money');
    if (!el) return 0;

    var priceRaw = el.getAttribute('original_price');
    var value = priceRaw ? parseFloat(priceRaw.replace(/[^0-9.]/g, '')) : 0;

    return value ? value : 0;
  }

  function fireViewCart() {

    var items = getCartItems();
    if (!items.length) return;

   // console.log(items);

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({ ecommerce: null });

    window.dataLayer.push({
      event: "view_cart_ce",
      page_type: window.GA_CONTEXT?.page_type || "cart",
      total_qty : items.length,
      platform: getPlatform(),
      user_id_event: window.GA_CONTEXT?.user_id,
      user_status: window.GA_CONTEXT?.user_status,
      ecommerce: {
        currency : "USD",
        value : getCartTotal(),
        items: items
      }
    });

    console.log("view_cart fired");
  }

  function initCartTracking() {

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var wasOpen = false;

    var observer = new MutationObserver(function () {

      var isOpen = drawer.classList.contains('active');
      
      // Fire ONLY when it transitions from closed → open
      if (isOpen && !wasOpen) {
        fireViewCart();
      }

      wasOpen = isOpen;

    });

    observer.observe(drawer, { attributes: true });

  }

  document.addEventListener("DOMContentLoaded", initCartTracking);

  document.addEventListener("DOMContentLoaded", function () {

    // cart page
    if (window.location.pathname === "/cart") {
          fireViewCart();
    }

  });

})();

/* Product Additional Functionality */
document.addEventListener('DOMContentLoaded', function() {
  // Tab functionality
  // Find all tab containers on the page (can be in multiple sections)
  const tabContainers = document.querySelectorAll('.slideshow_v2.tab-container');

 // console.log(tabContainers);
  tabContainers.forEach(container => {
    const tabBtns = container.querySelectorAll('.slideshow_v2 .tab-btn');
    const tabPanes = container.querySelectorAll('.slideshow_v2 .tab-pane');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const targetTabId = this.getAttribute('data-tab');

        // Remove 'active' from all buttons and panes in this container
        tabBtns.forEach(b => b.classList.remove('active'));
        tabPanes.forEach(p => p.classList.remove('active'));

        // Add 'active' to clicked button and matching pane
        this.classList.add('active');
        const targetPane = container.querySelector(`#${targetTabId}`);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  });
});